var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.00854492,
    y: 0.623932,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#4B00A8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6283 15.1833C18.3595 12.0026 15.1258 10.4442 14.9893 10.3805C14.8611 10.3168 14.7164 10.2998 14.5799 10.3253C10.8499 10.958 10.2875 13.1874 10.2669 13.2808C10.2379 13.4082 10.242 13.5441 10.2793 13.6715C14.7288 27.8463 23.9752 30.4748 27.0146 31.3411C27.2503 31.409 27.4406 31.46 27.5894 31.511C27.7548 31.5662 27.9368 31.5577 28.0981 31.4812C28.1932 31.4388 30.389 30.3772 30.9266 26.9078C30.9514 26.7549 30.9266 26.602 30.8604 26.4661C30.8108 26.3685 29.6653 24.1263 26.477 23.3322C26.2579 23.2728 26.0263 23.3322 25.8526 23.4851C24.8478 24.3684 23.4583 25.3069 22.8587 25.4045C18.8434 23.3875 16.5979 19.5189 16.5152 18.7843C16.4656 18.3724 17.3878 16.9243 18.4464 15.7438C18.5828 15.5952 18.649 15.3913 18.6283 15.1875V15.1833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/Phone Icon.a4d96e407444e16e3a098a7967fd8dbe.svg";
export { ForwardRef as ReactComponent };